import BasketAside from "components/BasketAside/BasketAside.vue"
import BasketCard from "components/BasketCard/BasketCard"
import debounce from 'foundation/js/debounce'
import interpolate from 'foundation/js/interpolate'

import { computed, onMounted, ref } from 'vue'
import { useStore } from "vuex"

export default {
    name: "Basket",
    components: {BasketAside, BasketCard},
    setup(){
        const store = useStore()
        const dataLoaded = ref(false)
      
        onMounted(() => {
            // delaying dataLoaded to avoid showing "Cart is empty" message for a split second
            store.dispatch('basket/fetchBasket').then(()=> debounce(_ => dataLoaded.value = true, 1000)())
        })
        
        const cartIsEmpty = computed(() => dataLoaded.value && store.state.basket.basket.length === 0)
        const hasErrors = computed(() => store.state.basket.basketState.hasErrors)
        const basketCards = computed(() => store.state.basket.basket)
        const getLabel = (labelKey, params) => interpolate(store.getters['labels/getLabel']({labelCollection: 'cart', labelKey}), params)
        const readOnlyAmount = computed(() => getLabel('readOnlyAmount')?.toLowerCase() === 'true')

        //#region Item removal functionality
        let deleteItemsQueue = []

        const removeItem = (item) => {
            if (item.immediate) {
                store.dispatch('basket/removeItems', [{ "sku": item.sku }])
                return
            }

            deleteItemsQueue.push(item.sku)

            debounce(function () {
                store.dispatch('basket/removeItems', deleteItemsQueue.map((sku) => ({"sku": sku})))
                deleteItemsQueue = []
                // only for FE simulation
                if(process.env.ENVIRONMENT == 'DEVELOP') displayAlreadyRemoved(false) 
            }, 5000)()
        }

        const cancelRemoveItem = (sku) => {
            deleteItemsQueue = _removeItemFromQueue(sku) || []; // deleteItemsQueue is assumed to never be null/undefined
        }

        const _removeItemFromQueue = (itemSku) => {
            return deleteItemsQueue.filter(function (sku) {
                return sku !== itemSku;
            });
        }
        //#endregion End: Item removal functionality

        return {
            basketCards,
            cartIsEmpty,
            hasErrors,
            getLabel,
            removeItem,
            cancelRemoveItem,
            readOnlyAmount
        }
    }
}